import React, { useState, useEffect, useRef } from "react";
import { useAuth, db } from "../context/authContext";
import { collection, query, onSnapshot, doc, getDoc, updateDoc, where, orderBy, limit, setDoc } from "firebase/firestore";
import Reloj from "./Reloj.js";
import Calorias from "./Calorias.js";
import Distancia from "./Distancia.js";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useRPM } from "../hooks/useRPM";
import logo from "../assets/Logo.png";

// 🔹 Hooks nuevos
import { useSyncRPM } from "../hooks/useSyncRPM";

// 🔹 RTDB
import { rtdb } from "../firebase";
import { ref, onValue, remove, set } from "firebase/database";

// 🔹 Emojis disponibles
const EMOJIS_FAKE = ["❤️", "👍", "💪", "😅", "👊", "💦", "🐘", "🏆", "👏", "🥵"];

// 🔹 Nombres fake (solo 4 usuarios)
const NOMBRES_FAKE = [
  "Sara", "Alex", "Ana", "Juan",
  "Elena"
];

export function Home() {
  const {
    logout,
    loading,
    EstadoLogout,
    addRanking,
    enviarEmoji,
    addInfoGym,
    darPropina,
    comprarTokens,
    user,
  } = useAuth();

  const navigate = useNavigate();

  const wakeLockRef = useRef(null);

  // 🔹 Detectar si volvemos a la clase desde Ranking o ResumenEntreno
  useEffect(() => {
    const internalNav = localStorage.getItem("internalNav");

    if (internalNav) {
      console.log("🔄 Volviendo a clase con internalNav → no reseteamos nada");
      localStorage.removeItem("internalNav"); // limpiar la marca
      return; // 👈 evitamos que se ejecute la lógica de reset
    }

    // ⚠️ Si NO venimos de internalNav, sigue la lógica normal (se ejecutarán los otros useEffect)
  }, []);

  useEffect(() => {
    const activarWakeLock = async () => {
      try {
        if ("wakeLock" in navigator && document.visibilityState === "visible") {
          wakeLockRef.current = await navigator.wakeLock.request("screen");
          console.log("🔆 Wake Lock activado");
        }
      } catch (err) {
        console.error("❌ No se pudo activar Wake Lock:", err);
      }
    };

    const reactivarWakeLock = async () => {
      if (
        document.visibilityState === "visible" &&
        "wakeLock" in navigator &&
        !wakeLockRef.current
      ) {
        await activarWakeLock();
      }
    };

    activarWakeLock();

    document.addEventListener("visibilitychange", reactivarWakeLock);

    return () => {
      document.removeEventListener("visibilitychange", reactivarWakeLock);

      if (wakeLockRef.current) {
        wakeLockRef.current.release().catch(() => { });
        wakeLockRef.current = null;
      }
    };
  }, []);


  // Estados
  const [mensajeError, setMensajeError] = useState("");
  const [personas, setPersonas] = useState([]);
  const [personasUser, setPersonasUser] = useState("");
  const [emojis, setEmojis] = useState("");
  const [puntosRanking, setPuntosRanking] = useState(0);
  const [rpmUsuarios, setRpmUsuarios] = useState({});
  const [estadoClase, setEstadoClase] = useState(null);
  const [customPropina, setCustomPropina] = useState("");
  const [isGym, setIsGym] = useState(true);
  const [tokens, setTokens] = useState(0);
  const [personasFake, setPersonasFake] = useState([]);
  const [lobbyActivo, setLobbyActivo] = useState(false);


  // Estados
  const [puntosSesion, setPuntosSesion] = useState(0);   // progreso al bonus
  const [puntosTotales, setPuntosTotales] = useState(0); // acumulado ranking
  const [puntosLocal, setPuntosLocal] = useState(0);     // en memoria (emojis)
  const [nombreUsuario, setNombreUsuario] = useState(""); // si no existe, añade
  const [nombreGym, setNombreGym] = useState("");
  const [claseNombre, setClaseNombre] = useState("");


  // Hook de RPM
  const { rpm, started, startDetection, stopDetection } = useRPM();

  const [energy, setEnergy] = useState(0);
  const energyRef = useRef(0);
  const energyColor =
    energy <= 200
      ? "text-green-400"
      : energy <= 500
        ? "text-yellow-400"
        : energy <= 750
          ? "text-orange-400"
          : "text-red-500";

  useEffect(() => {
    if (rpm <= 5) {
      energyRef.current = 0;
      setEnergy(0);
      return;
    }

    const targetEnergy = Math.max(
      0,
      Math.min(1000, Math.round((rpm / 120) * 1000))
    );

    const nuevaEnergy = Math.round(
      energyRef.current * 0.9 + targetEnergy * 0.1
    );

    energyRef.current = nuevaEnergy;
    setEnergy(nuevaEnergy);
  }, [rpm]);

  //const energy = Math.max(0, Math.min(1000, Math.round((rpm / 120) * 1000)));

  // Enviar RPM en vivo → RTDB

  // 2️⃣ Llamar al hook con valores dinámicos
  // Enviar RPM en vivo → RTDB
  useSyncRPM(rpm, energy, started, nombreGym, claseNombre, nombreUsuario, estadoClase);

  // 2️⃣ buscar nombre usuario

  useEffect(() => {
    const nombreGuardado = JSON.parse(localStorage.getItem("nombre")) || "Anónimo";
    setNombreUsuario(nombreGuardado);
  }, []);


  // 3️⃣ Suscribirte al nodo correcto en RTDB

  // 🔹 Marcar usuario como activo al entrar en Home SOLO si el último contexto no era /comprobacion

  useEffect(() => {
    const activarUsuario = async () => {
      if (!user?.uid || !nombreGym || !claseNombre) return;

      try {
        const userRef = doc(db, "usuarios", user.uid);
        const snap = await getDoc(userRef);

        if (snap.exists()) {
          await updateDoc(userRef, {
            activo: true,
            ultimoContexto: "/home",
          });

          console.log("🟢 Usuario activo en Firestore + contexto /home");

          const rtdbRef = ref(
            rtdb,
            `clases/${nombreGym}/${claseNombre}/usuarios/${user.uid}`
          );

          const data = snap.data();

          await set(rtdbRef, {
            nombre: data.nombre || nombreUsuario || "Anónimo",
            rpm: 0,
            energy: 0,
            activo: true,
          });

          console.log("🟢 Usuario añadido en RTDB con rpm=0");
        }
      } catch (err) {
        console.error("❌ Error al activar usuario:", err);
      }
    };

    activarUsuario();
  }, [user?.uid, nombreGym, claseNombre, nombreUsuario]);


  // 2️⃣ Marcar inactivo al cerrar la pestaña
  useEffect(() => {
    const handleBeforeUnload = async () => {
      try {
        if (user?.uid) {
          const userRef = doc(db, "usuarios", user.uid);
          await updateDoc(userRef, { activo: false });
          console.log("🚪 Usuario marcado inactivo al cerrar Home");
        }
      } catch (err) {
        console.error("❌ Error al marcar inactivo en Home:", err);
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [user]);

  useEffect(() => {
    if (!started) {
      setModalMessage("⚡ Activa sensores para empezar a pedalear 🚴‍♂️");
      setModalType("success");
      setModalOpen(true);
    }
  }, [started]);

  const syncPuntos = async () => {
    try {
      if (!user?.uid) return;

      const fecha = new Date();
      const nombreMes = new Intl.DateTimeFormat("es-ES", { month: "long" }).format(fecha);
      const mesHoy = nombreMes.charAt(0).toUpperCase() + nombreMes.slice(1);

      const rankingRef = doc(db, "config", "rankingMensual");
      const rankingSnap = await getDoc(rankingRef);

      let mesActivo = mesHoy;

      if (!rankingSnap.exists()) {
        await setDoc(rankingRef, {
          mesActivo: mesHoy,
          updatedAt: Date.now(),
        });
        mesActivo = mesHoy;
      } else {
        const rankingData = rankingSnap.data();

        if (rankingData.mesActivo !== mesHoy) {
          await setDoc(
            rankingRef,
            {
              mesActivo: mesHoy,
              updatedAt: Date.now(),
            },
            { merge: true }
          );
          mesActivo = mesHoy;
        } else {
          mesActivo = rankingData.mesActivo || mesHoy;
        }
      }

      const userRef = doc(db, "usuarios", user.uid);
      const snap = await getDoc(userRef);
      const data = snap.exists() ? snap.data() : {};

      const mismoMes = data.mesReseteado === mesActivo;

      const baseTotales = mismoMes ? (data.puntosTotales || 0) : 0;
      const baseSesion = mismoMes ? (puntosSesion || 0) : 0;

      const nuevosTotales = baseTotales + puntosLocal;
      const nuevaSesion = baseSesion + puntosLocal;

      const totalesRedondeados = Math.floor(nuevosTotales);
      const sesionRedondeada = Math.floor(nuevaSesion);

      await updateDoc(userRef, {
        puntosTotales: totalesRedondeados,
        puntosSesion: sesionRedondeada,
        mesReseteado: mesActivo,
      });

      setPuntosTotales(totalesRedondeados);
      setPuntosSesion(sesionRedondeada);
      setPuntosLocal(0);

      console.log(
        `✅ Sync → Mes: ${mesActivo}, Sesión: ${sesionRedondeada}, Totales: ${totalesRedondeados}`
      );
    } catch (err) {
      console.error("❌ Error al sincronizar puntos:", err);
    }
  };

  // Validar que cambio de dia y toca volver a pagar token

  useEffect(() => {
    const validarSesion = async () => {
      if (!user?.uid) return;        // 👈 si no hay usuario, nada

      const userRef = doc(db, "usuarios", user.uid);
      const userSnap = await getDoc(userRef);
      if (!userSnap.exists()) return;

      const data = userSnap.data();
      const hoy = new Date().toISOString().split("T")[0];

      // ⚡ Solo validamos por fecha
      if (data.ultimoAcceso && data.ultimoAcceso !== hoy) {
        console.warn("⚠️ Día distinto, requiere comprobación");
        navigate("/comprobacion");
        return;
      }

      console.log("✅ Sesión validada (solo fecha):", { ultimoAcceso: data.ultimoAcceso });
    };

    validarSesion();
  }, [user, navigate]);

  //Validar que estoy en home

  useEffect(() => {
    localStorage.setItem("lastPage", "home");
  }, []);

  // Guardar contexto en Firestore → "/home"
  useEffect(() => {
    if (!user?.uid) return;

    const userRef = doc(db, "usuarios", user.uid);
    updateDoc(userRef, { ultimoContexto: "/home" })
      .then(() => console.log("📝 Contexto guardado en Firestore: /home"))
      .catch(err => console.error("❌ Error guardando contexto:", err));
  }, [user]);


  // 👉 Handlers

  // 🔹 Emojis
  const EMOJIS = ["❤️", "👍", "💪", "😅", "👊", "💦", "🐘", "🏆", "👏", "🥵"];

  const handleEmoji = async (icon) => {
    try {
      setEmojis(icon);
      setTimeout(() => setEmojis(""), 5000);

      // 👇 Incrementar contador de emojis lanzados
      setPuntosRanking((prev) => prev + 1);

      setPuntosLocal((prev) => {
        // ➕ ahora suma 0.1 puntos en lugar de 1
        const nuevosLocal = parseFloat((prev + 0.1).toFixed(1));
        const totalSesion = parseFloat((puntosSesion + nuevosLocal).toFixed(1));

        if (totalSesion > 0 && Math.round(totalSesion) % 1000 === 0) {
          checkBonus(totalSesion);
        } else {
          console.log("👉 Local:", nuevosLocal, "Total sesión:", totalSesion);
        }

        return nuevosLocal;
      });

      // 👉 🔥 Enviar emoji a Firebase para que lo vean los demás

      await enviarEmoji(icon);

    } catch (err) {
      console.error("Error en handleEmoji:", err);
    }
  };

  // 🎁 Control de último bonus con useRef
  const lastBonusGivenRef = React.useRef(0);

  const checkBonus = async (puntosTotalesSesion) => {
    const totalEntero = Math.floor(puntosTotalesSesion);
    const umbral = Math.floor(totalEntero / 1000) * 1000;

    if (umbral > 0 && umbral !== lastBonusGivenRef.current) {
      lastBonusGivenRef.current = umbral;

      try {
        if (!isGym) {
          // Solo usuarios fuera de gym reciben tokens
          await comprarTokens(user.uid, 1, { metodo: "bonus" });
          console.log("🎁 BONUS con token en:", umbral);

          setModalType("success");
          setModalMessage(`🎉 ¡Has ganado 1 token extra por alcanzar ${umbral} puntos!`);
        } else {
          // En gym: solo mostrar mensaje, no sumar token
          console.log("🎉 BONUS alcanzado en gym (sin token):", umbral);

          setModalType("success");
          setModalMessage(`🚴 ¡Enhorabuena, has alcanzado ${umbral} puntos!
                👉 Tus puntos cuentan para el ranking, sigue pedaleando 💪`);

        }

        setModalOpen(true);
      } catch (err) {
        console.error("❌ Error en checkBonus acumulativo:", err);
      }
    }
  };





  const handleLogout = async () => {
    try {
      if (user?.uid && nombreGym && claseNombre) {
        // 🔥 Borrar nodo RTDB al salir explícitamente
        const userRef = ref(rtdb, `clases/${nombreGym}/${claseNombre}/usuarios/${user.uid}`);
        await remove(userRef);
        console.log("🧹 Nodo RTDB del usuario eliminado al hacer logout");
      }

      if (user?.uid) {
        await syncPuntos();
        const userRef = doc(db, "usuarios", user.uid);
        await updateDoc(userRef, { puntosSesion: 0 });
        await addRanking();
        await EstadoLogout();
      }

      setPuntosSesion(0);
      setPuntosLocal(0);
      stopDetection();
      localStorage.removeItem("gimnasio");
      localStorage.setItem("logout", Date.now());

      await logout();
      console.log("✅ Logout completo y sincronizado");
    } catch (err) {
      console.error("❌ Error en logout:", err);
    }
  };


  const handleGuardar = async () => {
    try {
      await syncPuntos();

      const userRef = doc(db, "usuarios", user.uid);
      await updateDoc(userRef, { puntosSesion: 0 });
      setPuntosSesion(0);
      setPuntosLocal(0);

      // 🔹 Recuperamos ids ANTES de borrarlos
      //const claseId = claseNombre;
      //const gimnasio = nombreGym;

      const claseId = claseNombre;
      const gimnasio = nombreGym;

      const nuevoEntreno = {
        fecha: new Date().toLocaleDateString(),
        duracion: document.getElementById("reloj-duracion")?.innerText || "00:00",
        distancia: document.getElementById("distancia-recorrido")?.innerText || "0 Km",
        calorias: document.getElementById("calorias-gastadas")?.innerText || "0 Kcal",
        cadenciaMedia: rpm,
        emojis: puntosRanking,
        puntos: Math.floor(puntosSesion + puntosLocal),
        modo: "Premium",
        claseId,      // 👈 guardamos claseId
        gimnasio,     // 👈 guardamos gimnasio
      };

      // 🔍 Cargar historial y comprobar duplicados
      const entrenos =
        JSON.parse(localStorage.getItem("historialEntrenos") || "[]") || [];

      const yaExiste = entrenos.some(
        (e) =>
          e.fecha === nuevoEntreno.fecha &&
          e.claseId === nuevoEntreno.claseId &&
          e.gimnasio === nuevoEntreno.gimnasio
      );

      if (yaExiste) {
        setModalType("error");
        setModalMessage("⚠️ Este entreno ya fue guardado.");
        setModalOpen(true);
        return; // 👈 salimos sin guardar nada
      }

      // Guardar nuevo entreno
      entrenos.push(nuevoEntreno);
      localStorage.setItem("historialEntrenos", JSON.stringify(entrenos));

      await addRanking();

      navigate("/resumentreno");
    } catch (err) {
      console.error("❌ Error al guardar entreno:", err);
      setModalType("error");
      setModalMessage("❌ Error al guardar el entreno.");
      setModalOpen(true);
    }
  };


  const handleRanking = async () => {
    try {
      await syncPuntos(); // 👈 añadimos aquí
      // Reset de puntos aquí
      const userRef = doc(db, "usuarios", user.uid);
      await updateDoc(userRef, { puntosSesion: 0 });
      setPuntosSesion(0);
      setPuntosLocal(0);

      await addRanking();
      navigate("/Ranking");
    } catch { }
  };

  const handleCerrarClase = async () => {
    try {
      if (user?.uid && nombreGym && claseNombre) {
        const userRef = ref(rtdb, `clases/${nombreGym}/${claseNombre}/usuarios/${user.uid}`);
        await remove(userRef);
        console.log("🧹 Nodo RTDB del usuario eliminado al cerrar clase");
      }

      await syncPuntos();
      if (user?.uid) {
        const userRef = doc(db, "usuarios", user.uid);
        await updateDoc(userRef, { puntosSesion: 0 });
      }

      setPuntosSesion(0);
      setPuntosLocal(0);
      stopDetection();
      await addRanking();
      await addInfoGym("", "");
      await EstadoLogout();
      localStorage.removeItem("gimnasio");
      localStorage.setItem("cerrarClase", Date.now());

      navigate("/comprobacion");
    } catch (err) {
      console.error("❌ Error al cerrar clase:", err);
    }
  };


  // Estados nuevos
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [modalType, setModalType] = useState("success"); // "success" | "error"

  const handlePropina = async (cantidad) => {
    try {
      const claseId = nombreGym;

      if (!claseId) {
        setModalType("error");
        setModalMessage("⚠️ No hay canal/gimnasio seleccionado.");
        setModalOpen(true);
        return;
      }

      const userRef = doc(db, "usuarios", user.uid);
      const userSnap = await getDoc(userRef);
      const userData = userSnap.exists() ? userSnap.data() : {};
      const nombre = userData.nombre || nombreUsuario || "Usuario";

      const ok = await darPropina(user.uid, claseId, cantidad, nombre);
      if (ok) {
        setModalType("success");
        setModalMessage(`🎉 Has dado ${cantidad} tokens de propina`);
      } else {
        setModalType("error");
        setModalMessage("❌ No tienes suficientes tokens");
      }
      setCustomPropina("");
      setModalOpen(true);
    } catch (err) {
      console.error("❌ Error al dar propina:", err);
      setModalType("error");
      setModalMessage("❌ Error al procesar la propina.");
      setModalOpen(true);
    }
  };

  // ------------------ EFFECTS ------------------


  // 🔹 Reaccionar a cambios en estadoClase + lobbyActivo
  useEffect(() => {
    if (estadoClase === "cerrada") {
      if (lobbyActivo) {
        // ✅ Caso 1: Clase cerrada pero lobby activo
        // No limpiamos nombreGym/claseId → usuario sigue "esperando"
        setModalType("success");
        setModalMessage(
          "⏳ La clase está cerrada por ahora. El lobby está activo, espera a que el instructor abra la clase 🚴‍♂️"
        );
        setModalOpen(true);

        // 👇 Importante: NO limpiar datos de Firestore ni localStorage aquí
        // porque si no el usuario perdería el acceso cuando se abra la clase
      } else {
        // 🚪 Caso 2: Clase cerrada y lobby también desactivado
        // Guardamos entreno, limpiamos datos y sacamos al usuario
        (async () => {
          try {
            await syncPuntos(); // guardar puntos antes de salir
            if (user?.uid) {
              const userRef = doc(db, "usuarios", user.uid);
              await updateDoc(userRef, { nombreGym: "", claseId: "" });
            }
            localStorage.removeItem("gimnasio");
            localStorage.removeItem("claseId");

            setPuntosSesion(0);
            setPuntosLocal(0);

            setModalType("error");
            setModalMessage(
              "🚪 La clase ha terminado y el lobby está cerrado. Selecciona un nuevo gimnasio o canal."
            );
            setModalOpen(true);

            // redirigir después de unos segundos
            setTimeout(() => {
              navigate("/comprobacion");
            }, 4000);
          } catch (err) {
            console.error("❌ Error al limpiar al cerrar clase:", err);
          }
        })();
      }
    }
  }, [estadoClase, lobbyActivo, navigate, user]);



  // 🔹 Suscripción Firestore → cambios en claseId dentro de Claves/{gymId}
  useEffect(() => {
    const gimnasioGuardado = JSON.parse(localStorage.getItem("gimnasio"));
    if (!gimnasioGuardado) return;

    const estadoRef = doc(db, "claves", gimnasioGuardado);

    const unsubscribe = onSnapshot(estadoRef, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.data();

        // Estado de la clase
        setEstadoClase(data.estado?.toLowerCase() || "cerrada");
        setIsGym(data.isGym ?? true);
        setLobbyActivo(data.lobbyActivo ?? false);
        setNombreGym(data.nombre || "Mi Gimnasio");

        // ⚡ si cambia el claseId (nombre de la clase), lo actualizamos
        if (data.claseId) {
          setClaseNombre(data.claseId);
        }
      }
    });

    return () => unsubscribe();
  }, []);


  // Suscripción Firestore (usuarios en vivo)
  useEffect(() => {
    const gimnasioGuardado = JSON.parse(localStorage.getItem("gimnasio"));
    const userSinGym = JSON.parse(localStorage.getItem("usuario"));
    // const userSinGym = JSON.parse(localStorage.getItem("user.uid")); esto no pongas porque sale Yo si lo pones en vez del nombre Chris

    const nombre = JSON.parse(localStorage.getItem("nombre"));

    if (!gimnasioGuardado || !userSinGym) return;

    const q = query(collection(db, "usuarios"));
    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const personasActivasEnGimnasio = snapshot.docs
          .map((doc) => doc.data())
          .filter(
            (p) =>
              p.activo &&
              p.nombreGym === gimnasioGuardado &&
              p.uidd !== userSinGym
          )
          .map((p) => ({
            uid: p.uidd,
            nombre: p.nombre,
            mensaje: p.mensajes,
            puntos: p.puntosTotales || 0
          }));

        setPersonas(personasActivasEnGimnasio);
        setPersonasUser(nombre);
      },
      () => setMensajeError("⚠️ No se pudo cargar la lista de usuarios.")
    );

    return () => unsubscribe();
  }, []);

  // 🔹 Inicializar usuarios fake cuando no es Gym
  useEffect(() => {
    if (!isGym) {
      const inicial = NOMBRES_FAKE.map((nombre) => ({
        nombre,
        rpm: Math.floor(Math.random() * 40) + 60,
        emojiActivo: null,
      }));
      setPersonasFake(inicial);
    }
  }, [isGym]);

  // 🔹 Actualizar fake cada 8s
  useEffect(() => {
    if (!isGym) {
      const interval = setInterval(() => {
        setPersonasFake((prev) =>
          prev.map((p) => {
            const nuevaRpm = Math.floor(Math.random() * 40) + 60;
            const lanzarEmoji = Math.random() < 0.4;
            const emojiRandom = lanzarEmoji
              ? EMOJIS_FAKE[Math.floor(Math.random() * EMOJIS_FAKE.length)]
              : null;
            return { ...p, rpm: nuevaRpm, emojiActivo: emojiRandom };
          })
        );

        // 🔹 resetear emoji después de 5s
        setTimeout(() => {
          setPersonasFake((prev) => prev.map((p) => ({ ...p, emojiActivo: null })));
        }, 5000);
      }, 8000);

      return () => clearInterval(interval);
    }
  }, [isGym]);




  // 🔹 Suscripción Firestore → tokens en vivo
  useEffect(() => {
    if (!user?.uid) return;
    const userRef = doc(db, "usuarios", user.uid);
    const unsubscribe = onSnapshot(userRef, (snapshot) => {
      if (snapshot.exists()) {
        setTokens(snapshot.data().tokens || 0);
        localStorage.setItem("Tokens", snapshot.data().tokens || 0);
      }
    });
    return () => unsubscribe();
  }, [user]);


  // 🔹 Cargar puntos iniciales SOLO una vez

  useEffect(() => {
    const fetchInitial = async () => {
      if (!user?.uid) return;

      const fecha = new Date();
      const nombreMes = new Intl.DateTimeFormat("es-ES", { month: "long" }).format(fecha);
      const mesHoy = nombreMes.charAt(0).toUpperCase() + nombreMes.slice(1);

      const rankingRef = doc(db, "config", "rankingMensual");
      const rankingSnap = await getDoc(rankingRef);

      let mesActivo = mesHoy;

      if (!rankingSnap.exists()) {
        await setDoc(rankingRef, {
          mesActivo: mesHoy,
          updatedAt: Date.now(),
        });
        mesActivo = mesHoy;
      } else {
        const rankingData = rankingSnap.data();
        mesActivo = rankingData?.mesActivo || mesHoy;
      }

      const userRef = doc(db, "usuarios", user.uid);
      const snap = await getDoc(userRef);

      if (snap.exists()) {
        const data = snap.data();

        const mismoMes = data.mesReseteado === mesActivo;
        const sesion = mismoMes ? (data.puntosSesion || 0) : 0;
        const totales = mismoMes ? (data.puntosTotales || 0) : 0;

        setPuntosSesion(sesion);
        setPuntosTotales(totales);

        localStorage.setItem("PuntosSesion", sesion);
        localStorage.setItem("PuntosTotales", totales);

        console.log("🔥 Puntos iniciales cargados:", { mesActivo, sesion, totales });
      }
    };

    fetchInitial();
  }, [user]);


  // 🔹 Efecto para sumar puntos automáticamente cada 5 minutos en base a RPM

  useEffect(() => {
    if (!started) return; // solo si los sensores están activos

    const interval = setInterval(() => {
      if (rpm > 0) {
        const puntosGanados = Math.floor(rpm / 10); // ej: 80rpm = 8 puntos

        setPuntosLocal((prev) => {
          const nuevosLocal = prev + puntosGanados;

          // 🔹 Ojo: usamos la versión actualizada de puntosSesion con el setter
          const totalSesion = puntosSesion + nuevosLocal;

          console.log(`⏱️ AutoPuntos: +${puntosGanados} (RPM=${rpm}) → Sesión=${totalSesion}`);

          // ✅ Ahora chequeamos correctamente bonus
          checkBonus(totalSesion);

          return nuevosLocal;
        });
      }
    }, 2 * 60 * 1000); // cada 2 minutos

    return () => clearInterval(interval); // limpiar al salir
  }, [started, rpm, puntosSesion]);

  const [propinaAnimada, setPropinaAnimada] = useState(null);

  useEffect(() => {
    const gimnasioGuardado = JSON.parse(localStorage.getItem("gimnasio"));
    if (!gimnasioGuardado) return;

    const q = query(
      collection(db, "propinas"),
      where("claseId", "==", gimnasioGuardado),
      orderBy("timestamp", "desc"),
      limit(1) // 👈 solo la más reciente
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      if (!snapshot.empty) {
        const ultima = snapshot.docs[0].data();
        console.log("💸 Última propina (orderby):", ultima);

        setPropinaAnimada(ultima);

        // se borra sola después de 5 s
        setTimeout(() => setPropinaAnimada(null), 5000);
      }
    });

    return () => unsubscribe();
  }, []);

  // ----Si la clase se cierra y se vuelve a abrir puntos a cero ------------------

  useEffect(() => {
    if (estadoClase === "abierta") {
      setPuntosSesion(0);
      setPuntosLocal(0);

      if (user?.uid) {
        const userRef = doc(db, "usuarios", user.uid);
        updateDoc(userRef, { puntosSesion: 0 });
      }

      console.log("🚀 Nueva clase abierta → contador reiniciado");
    }
  }, [estadoClase, user]);


  // ------------------ RENDER ------------------

  if (loading) return <h1 className="text-center mt-10">⏳ Loading...</h1>;

  return (
    <div className="w-screen min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-800 flex flex-col items-center text-white">
      {/* Header */}
      <div className="text-center mt-6">
        <img src={logo} alt="Logo" className="mx-auto w-40 mb-3" />

        <p className="text-lg font-bold italic">
          {nombreGym
            ? `🏋️ ${nombreGym}${claseNombre ? ` — 🚴 ${claseNombre}` : ""}`
            : "💪 Tu mejor versión empieza ahora"}
        </p>


      </div>

      {/* 👉 Monedero y puntos */}
      <div className="flex flex-col items-center mb-4">
        {/* Tokens para todos sea gym o youtuber */}
        <>
          <p className="text-xl font-bold text-yellow-400">
            🎟️ Tokens: {tokens}
          </p>
          <button
            onClick={() => navigate("/comprar-tokens")}
            
            className="mt-2 px-4 py-2 bg-yellow-500 hover:bg-yellow-600 text-white font-semibold rounded-lg shadow-md transition"
          >
            Comprar Tokens
          </button>
        </>

        {/* Puntos acumulados (mostrar siempre) */}
        <p className="text-md font-semibold text-green-400 mt-3">
          🏆 Puntos sesión: {Math.floor(puntosSesion + puntosLocal)}
        </p>

        {/* Barra de progreso */}
        <div className="w-64 bg-gray-700 rounded-full h-4 mt-2 overflow-hidden">
          <div
            className="bg-green-500 h-4"
            style={{
              width: `${(((puntosSesion + puntosLocal) % 1000) / 1000) * 100}%`
            }}
          ></div>
        </div>

        <p className="text-sm text-gray-300 mt-1">
          {(Math.floor(puntosSesion + puntosLocal) % 1000)} / 1000 puntos para bonus
        </p>
      </div>

      {/* Estado clase */}
      <p className="mb-4 text-sm">
        Estado clase:{" "}
        <span
          className={`px-3 py-1 rounded-full text-xs ${estadoClase === "abierta"
            ? "bg-green-500/20 text-green-400"
            : "bg-red-500/20 text-red-400"
            }`}
        >
          {estadoClase === "cerrada"
            ? "CERRADA (por el admin)"
            : estadoClase?.toUpperCase()}
        </span>
      </p>
      <p className="mb-4 text-xs text-yellow-300 text-center px-4">
        Mantén la pantalla encendida durante la clase para que las RPM sigan actualizándose.
      </p>

      {/* Métricas */}
      <div className="grid grid-cols-3 gap-4 w-full max-w-md mb-6">
        <div className="bg-white/10 backdrop-blur-md rounded-xl py-4 text-center shadow-md">
          <p id="reloj-duracion" className="text-xl font-bold">
            <Reloj />
          </p>
          <p className="text-gray-300 text-sm">Duración</p>
        </div>
        <div className="bg-white/10 backdrop-blur-md rounded-xl py-4 text-center shadow-md">
          <p
            id="distancia-recorrido"
            className="text-xl font-bold text-blue-400"
          >
            <Distancia rpm={rpm} />
          </p>
          <p className="text-gray-300 text-sm">Distancia</p>
        </div>
        <div className="bg-white/10 backdrop-blur-md rounded-xl py-4 text-center shadow-md">
          <p
            id="calorias-gastadas"
            className="text-xl font-bold text-orange-400"
          >
            <Calorias rpm={rpm} />
          </p>
          <p className="text-gray-300 text-sm">Calorías</p>
        </div>
      </div>

      {mensajeError && (
        <p className="text-red-400 font-semibold mb-3">{mensajeError}</p>
      )}

      {/* RPM central protagonista */}
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="bg-white/10 backdrop-blur-lg rounded-full w-56 h-56 flex flex-col items-center justify-center shadow-lg mb-6 relative"
      >
        <p className="text-md mb-1">{personasUser || "Yo"}</p>
        <p className={`text-6xl font-extrabold ${energyColor}`}>{energy}</p>

        <p className={`text-md font-semibold ${energyColor}`}>Energy</p>
        <p className="text-sm text-gray-300 mt-1">{rpm} RPM</p>

        {/* 👇 Emojis animados */}
        {emojis && (
          <p className="text-5xl mt-2 animate-bounce">{emojis}</p>
        )}

        {/* 👇 Propinas animadas */}
        {propinaAnimada && (
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -30 }}
            transition={{ duration: 0.5 }}
            className="absolute -bottom-16 text-yellow-300 text-5xl font-extrabold drop-shadow-[0_0_10px_rgba(255,255,0,0.8)]"
          >
            💸 {propinaAnimada.nombreUsuario} dio {propinaAnimada.cantidad} 🎟️
          </motion.div>
        )}
      </motion.div>

      {/* Botón sensores */}
      {!started && (
        <button
          onClick={startDetection}
          className="mb-4 px-4 py-2 bg-blue-500 text-white rounded-lg shadow-md text-sm"
        >
          Activar sensores
        </button>
      )}

      {/* Emojis */}
      <div className="w-full max-w-md px-2 mb-6">
        <h2 className="text-md font-semibold mt-2 mb-2">Reacciona</h2>
        <div className="grid grid-cols-5 gap-2">
          {["❤️", "👍", "💪", "😅", "👊", "💦", "🐘", "🏆", "👏", "🥵"].map(
            (icon, i) => (
              <button
                key={i}
                onClick={() => handleEmoji(icon)}
                className="bg-white/10 hover:bg-white/20 rounded-lg py-3 text-2xl shadow-md transition"
              >
                {icon}
              </button>
            )
          )}
        </div>
      </div>

      {/* 👉 Propinas */}


      <>
        <h2 className="text-md font-semibold mt-4 mb-2">
          Dar propina al instructor
        </h2>
        <div className="grid grid-cols-4 gap-2 w-full max-w-md px-4 mb-4">
          {[1, 5, 10, 20].map((cantidad) => (
            <button
              key={cantidad}
              onClick={() => handlePropina(cantidad)}
              className="bg-yellow-500/20 hover:bg-yellow-500/30 text-yellow-300 font-semibold py-2 rounded-lg shadow-md transition"
            >
              {cantidad} 🎟️
            </button>
          ))}
        </div>
        <div className="flex items-center gap-2 w-full max-w-md px-4 mb-8">
          <input
            type="number"
            min="1"
            placeholder="Cantidad"
            value={customPropina}
            onChange={(e) => setCustomPropina(e.target.value)}
            className="flex-1 px-3 py-2 rounded-lg text-black"
          />
          <button
            onClick={() => handlePropina(parseInt(customPropina || "0", 10))}
            className="bg-yellow-500 hover:bg-yellow-600 text-white font-semibold px-4 py-2 rounded-lg shadow-md transition"
          >
            Dar
          </button>
        </div>
      </>

      {/* Otros ciclistas */}
  
      {/* Botones acción */}
      <div className="grid grid-cols-2 gap-3 w-full max-w-md px-4 mb-10">
        <button
          onClick={handleGuardar}
          className="bg-gradient-to-r from-green-400 to-emerald-600 hover:from-green-500 hover:to-emerald-700 text-white font-semibold py-3 rounded-xl shadow-lg transition"
        >
          Guardar entreno
        </button>
        <button
          onClick={handleRanking}
          className="bg-gradient-to-r from-blue-400 to-indigo-600 hover:from-blue-500 hover:to-indigo-700 text-white font-semibold py-3 rounded-xl shadow-lg transition"
        >
          Ranking
        </button>

        <button
          onClick={() => navigate("/historial")}
          className="bg-gradient-to-r from-purple-400 to-purple-600 hover:from-purple-500 hover:to-purple-700 text-white font-semibold py-3 rounded-xl shadow-lg transition"
        >
          Ver historial
        </button>

        <button
          onClick={handleCerrarClase}
          className="bg-gradient-to-r from-yellow-400 to-orange-600 hover:from-yellow-500 hover:to-orange-700 text-white font-semibold py-3 rounded-xl shadow-lg transition"
        >
          🚪 Cerrar Clase
        </button>

        {/* 👇 Este ocupa toda la fila */}
        <button
          onClick={handleLogout}
          className="col-span-2 bg-gradient-to-r from-red-400 to-red-700 hover:from-red-500 hover:to-red-800 text-white font-semibold py-3 rounded-xl shadow-lg transition"
        >
          Logout
        </button>
      </div>

      {/* Modal de propinas */}
      {modalOpen && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
          <div className="bg-gray-900 text-white p-6 rounded-2xl shadow-xl w-80 text-center">
            <h2
              className={`text-lg font-bold mb-4 ${modalType === "success" ? "text-green-400" : "text-red-400"
                }`}
            >
              {modalMessage}
            </h2>
            <button
              onClick={() => setModalOpen(false)}
              className="mt-3 px-4 py-2 bg-blue-600 hover:bg-blue-700 rounded-lg shadow-md"
            >
              Cerrar
            </button>
          </div>
        </div>
      )}

      {/* Frase motivacional */}
      <div className="mt-6">
        <p className="text-gray-300 italic mb-6 text-center">
          "Hoy pedaleas por tu mejor versión 🚴‍♂️🔥"
        </p>
      </div>
    </div>
  );
}

export default Home;
